import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild,
    ElementRef
} from '@angular/core';
import { IdName } from '../domain/idname';
import { LookupService } from '../service/lookup.service';
import { TreeNode } from 'primeng/api';
import { Totaling } from '../domain/totaling';
import * as _ from 'lodash';
import { AccountService } from '../service/account.service';

@Component({
    selector: 'app-dimension-totaling-picker',
    templateUrl: './dimension-totaling-picker.component.html',
    styles: [
        `
            :host ::ng-deep .priority-2,
            :host ::ng-deep .priority-3,
            :host ::ng-deep .visibility-sm {
                display: none;
            }

            @media screen and (max-width: 39.938em) {
                :host ::ng-deep .visibility-sm {
                    display: inline;
                }
            }

            @media screen and (min-width: 40em) {
                :host ::ng-deep .priority-2 {
                    display: table-cell;
                }
            }

            @media screen and (min-width: 64em) {
                :host ::ng-deep .priority-3 {
                    display: table-cell;
                }
            }
        `
    ]
})
export class DimensionTotalingPickerComponent implements OnInit {
    constructor(
        private lookupService: LookupService) {

        this.items1 = [
            {
                label: 'Collapse All',
                icon: 'ui-expand-less',
                command: event => this.collapseValues()
            },
            {
                label: 'Expand All',
                icon: 'ui-expand-more',
                command: event => this.expandValues()
            }
        ];

        this.items2 = [
            {
                label: 'Collapse All',
                icon: 'ui-expand-less',
                command: event => this.collapseSelected()
            },
            {
                label: 'Expand All',
                icon: 'ui-expand-more',
                command: event => this.expandSelected()
            }
        ];

        this.items3 = [
            {
                label: 'Collapse All',
                icon: 'ui-expand-less',
                command: event => this.collapseRangeOne()
            },
            {
                label: 'Expand All',
                icon: 'ui-expand-more',
                command: event => this.expandRangeOne()
            }
        ];

        this.items4 = [
            {
                label: 'Collapse All',
                icon: 'ui-expand-less',
                command: event => this.collapseRangeTwo()
            },
            {
                label: 'Expand All',
                icon: 'ui-expand-more',
                command: event => this.expandRangeTwo()
            }
        ];
    }

    @Input() dimensionId: number;
    @Input() dimension: string;
    @Input() totaling: Totaling[];
    @Output() totalingChange = new EventEmitter();
    @Input() label: string;
    @Input() header: string;

    accounts: TreeNode[];
    dialogVisible = false;
    items1: any[];
    items2: any[];
    items3: any[];
    items4: any[];
    dimensionValues: TreeNode[];
    dimensionValuesRange1: TreeNode[];
    dimensionValuesRange2: TreeNode[];
    dimensionValuesSelected: TreeNode[];

    selected: Array<TreeNode>;
    selectedRight: Array<TreeNode>;
    _selectedRange1: TreeNode;

    set selectedRange1(value: any) {
        this._selectedRange1 = value;
        this.loadRange2();
    }

    get selectedRange1() {
        return this._selectedRange1;
    }

    selectedRange2: TreeNode;

    editingExistingChips = false;
    existingChipsObject: Totaling;

    tableColumns: any[];

    indexDimTotaling = 0;

    ngOnInit() {
        this.tableColumns = [{ field: 'code', header: 'Code', width: '30%' },  { field: 'name', header: 'Name', width: '70%' }];
        if (!this.dimensionValuesSelected) {
            this.dimensionValuesSelected = new Array<TreeNode>();
        }
    }

    changeTotaling(newValue) {
        this.totaling = newValue;
        this.totalingChange.emit(newValue);
    }

    clear() {
        this.dimension = '';
        this.dimensionId = undefined;
    }

    clearAlreadySelectedValues(objects)
    {
        //First remove ranges...

        for (var i = 0; i < this.totaling.length; i++)
        {
            if (this.totaling[i].Ids.includes(".."))
            {
                var ids = this.totaling[i].Ids.split("..");
                var startingId = ids[0];
                var endingId = ids[1];

                var startingIdIndex = objects.findIndex(item => item.data.id === parseInt(startingId));
                var endingIdIndex = objects.findIndex(item => item.data.id === parseInt(endingId));

                objects.splice(startingIdIndex, endingIdIndex - startingIdIndex + 1);
            }
        }

        //Then remove singles...

        for (var i = 0; i < this.totaling.length; i++)
        {
            if (!this.totaling[i].Ids.includes(".."))
            {
                var ids = this.totaling[i].Ids.split("|");
                for (var x = 0; x < ids.length; x++)
                {
                    objects.splice(objects.findIndex(item => item.data.id === parseInt(ids[x])), 1);
                }
            }
        }

        return objects;
    }

    refresh()
    {
        this.lookupService
            .getDimensionValues(this.dimensionId)
            .then(objects => {
                this.dimensionValuesSelected = [];

                //this.dimensionValues = this.clearAlreadySelectedValues(objects);
                this.dimensionValues = objects;

                this.collapseValues();

                this.dimensionValuesRange1 = objects;
                this.dimensionValuesRange2 = null;
                this.dialogVisible = true;

                if (this.editingExistingChips) {

                    const selectedIds = this.existingChipsObject.Ids;

                    if (selectedIds.includes('..')) {
                        this.indexDimTotaling = 1;
                        // it's a range
                        const rangeIds = [];
                        selectedIds.split('..').forEach(id => {
                            rangeIds.push(Number(id));
                        });

                        // range start - rangeIds[0], range end - rangeIds[1];
                        const startNode = this.dimensionValuesRange1.find(node => node.data.id === Number(rangeIds[0]));
                        this._selectedRange1 = startNode;
                        this.loadRange2();
                        const endNode = this.dimensionValuesRange1.find(node => node.data.id === Number(rangeIds[1]));
                        this.selectedRange2 = endNode;
                    } else {
                        this.indexDimTotaling = 0;
                        // it's not a range
                        selectedIds.split('|').forEach(id => {
                            // tslint:disable-next-line: no-shadowed-variable
                            const node = this.dimensionValues.find(node => node.data.id === Number(id));
                            this.pickNode(node);
                        });
                    }
                }
            });
    }

    showDialog(event) {
        this.editingExistingChips = false;
        if (event && event.value)
        {
            this.editingExistingChips = true;
            this.existingChipsObject = event.value;
        }
        this.refresh();
    }

    loadRange2() {
        this.lookupService
            .getDimensionValues(this.dimensionId)
            .then(objects => {
                if (this._selectedRange1) {
                    if (this._selectedRange1.parent) {
                        const accountForTree = _.cloneDeep(this._selectedRange1.parent.children);

                        accountForTree.forEach( n => {
                            n.children = null;
                            n.expanded = false;
                            n.leaf = true;
                        });

                        const accountsFinal = [];

                        accountForTree.forEach( n => {
                            if (n.data.code > this._selectedRange1.data.code) {
                                accountsFinal.push(n);
                            }
                        });



                        this.dimensionValuesRange2 = accountsFinal;
                    } else {
                        const accountForTree = _.cloneDeep(objects);

                        accountForTree.forEach( n => {
                            n.children = null;
                            n.expanded = false;
                            n.leaf = true;
                        });
                        this.dimensionValuesRange2 = accountForTree;

                        const accountsFinal = [];

                        accountForTree.forEach( n => {
                            if (n.data.code > this._selectedRange1.data.code) {
                                accountsFinal.push(n);
                            }
                        });



                        this.dimensionValuesRange2 = accountsFinal;
                    }
                }
            });
    }

    resetAllRanges() {
        this.lookupService
            .getDimensionValues(this.dimensionId)
            .then(objects => {
                this.dimensionValuesRange1 = objects;
                this.dimensionValuesRange2 = null;
            });
    }

    resetAllTrees() {
        this.lookupService
            .getDimensionValues(this.dimensionId)
            .then(objects => {
                this.dimensionValues = objects;
                this.dimensionValuesSelected = null;
            });
    }

    clearAllTrees() {
        this.dimensionValues.sort((a, b) => {
            return (a.data.code.localeCompare(b.data.code));
        });
        this.dimensionValues = [...this.dimensionValues];
        this.dimensionValuesSelected.sort((a, b) => {
            return (a.data.code.localeCompare(b.data.code));
        });
        this.dimensionValuesSelected = [...this.dimensionValuesSelected];

        if (this.selected) {
            this.selected.splice(0, this.selected.length);
            this.selected = [...this.selected];
        }

        if (this.selectedRight) {
            this.selectedRight.splice(0, this.selectedRight.length);
            this.selectedRight = [...this.selectedRight];
        }
    }

    pick() {
        if (this.selected) {
            this.selected.forEach(node => {
                this.pickNode(node);
            });
        }

        this.clearAllTrees();
    }

    pickNode(node) {
        this.dimensionValuesSelected.push(node);
        this.dimensionValuesSelected = [...this.dimensionValuesSelected];
        this.dimensionValues.splice(this.dimensionValues.findIndex(item => item.data.id === node.data.id), 1);
        this.dimensionValues = [...this.dimensionValues];
    }

    unpick() {
        if (this.selectedRight) {
            this.selectedRight.forEach(node => {
                this.unpickNode(node);
            });
        }

        this.clearAllTrees();
    }

    unpickNode(node) {
        this.dimensionValues.push(node);
        this.dimensionValues = [...this.dimensionValues];
        this.dimensionValuesSelected.splice(this.dimensionValuesSelected.findIndex(item => item.data.id === node.data.id), 1);
        this.dimensionValuesSelected = [...this.dimensionValuesSelected];
    }

    okClick() {
        // if ((this.selectedRange1 && this.selectedRange2) && (this.selectedRange1.parent !== this.selectedRange2.parent)) {
        //     this.messageService.add({
        //         severity: 'error',
        //         summary: 'Can not save report definition line',
        //         detail: 'Selected range boudaries are not on same level!'
        //     });
        //     return;
        // }

        if (this.indexDimTotaling === 0) {
            this.resetAllRanges();
        } else if (this.indexDimTotaling === 1) {
            this.resetAllTrees();
        }

        this.dialogVisible = false;

        if (!this.totaling ) {
            this.totaling = Array<Totaling>();
        }

        if (this.indexDimTotaling === 0) {
            let ids: string;
            let names: string;
            let descriptions: string;

            ids = '';
            names = '';
            descriptions = '';

            this.dimensionValuesSelected.forEach(element => {
                ids = ids + element.data.id + '|';
                names = names + element.data.code + '|';
                descriptions =
                    '<p>' +
                    descriptions +
                    element.data.code +
                    ' - ' +
                    element.data.name +
                    '</p>';
            });

            ids = ids.substring(0, ids.length - 1);
            names = names.substring(0, names.length - 1);

            if (this.editingExistingChips) {
                this.existingChipsObject.Type = 3;
                this.existingChipsObject.Ids = ids;
                this.existingChipsObject.Names = names;
                this.existingChipsObject.Descriptions = descriptions;
            } else {
                const chip = new Totaling();
                chip.Type = 3;
                chip.Ids = ids;
                chip.Names = names;
                chip.Descriptions = descriptions;
                this.totaling.push(chip);
            }
        } else if (this.indexDimTotaling === 1) {
            let ids: string;
            let names: string;
            let descriptions: string;

            ids = '';
            names = '';
            descriptions = '';

            ids =
                this.selectedRange1.data.id +
                '..' +
                this.selectedRange2.data.id;
            names =
                this.selectedRange1.data.code +
                '..' +
                this.selectedRange2.data.code;
            descriptions =
                this.selectedRange1.data.code + ' - ' + this.selectedRange1.data.name +
                '..' +
                this.selectedRange2.data.code + ' - ' + this.selectedRange2.data.name;

            if (this.editingExistingChips) {
                this.existingChipsObject.Type = 2;
                this.existingChipsObject.Ids = ids;
                this.existingChipsObject.Names = names;
                this.existingChipsObject.Descriptions = descriptions;
            } else {
                const chip2 = new Totaling();
                chip2.Type = 2;
                chip2.Ids = ids;
                chip2.Names = names;
                chip2.Descriptions = descriptions;
                this.totaling.push(chip2);
            }
        }

        this.changeTotaling(this.totaling);
    }

    handleChangeDimTotaling(i, e) {
        this.indexDimTotaling = e.index;
    }

    onRemove() {
        this.changeTotaling(this.totaling);
    }

    // Recursive function for expanding-collapsing

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (!node.leaf && node.children != null) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    // Collapse
    collapseValues() {
        if (this.dimensionValues) {
            this.dimensionValues.forEach(node => {
                this.expandRecursive(node, false);
            });
            this.dimensionValues = [...this.dimensionValues];
        }
    }

    collapseSelected() {
        if (this.dimensionValuesSelected) {
            this.dimensionValuesSelected.forEach(node => {
                this.expandRecursive(node, false);
            });
            this.dimensionValuesSelected = [...this.dimensionValuesSelected];
        }
    }
    collapseRangeOne() {
        if (this.dimensionValuesRange1) {
            this.dimensionValuesRange1.forEach(node => {
                this.expandRecursive(node, false);
            });
            this.dimensionValuesRange1 = [...this.dimensionValuesRange1];
        }
    }

    collapseRangeTwo() {
        if (this.dimensionValuesRange2) {
            this.dimensionValuesRange2.forEach(node => {
                this.expandRecursive(node, false);
            });
            this.dimensionValuesRange2 = [...this.dimensionValuesRange2];
        }
    }

    // Expand
    expandValues() {
        if (this.dimensionValues) {
            this.dimensionValues.forEach(node => {
                this.expandRecursive(node, true);
            });
            this.dimensionValues = [...this.dimensionValues];
        }
    }

    expandSelected() {
        if (this.dimensionValuesSelected) {
            this.dimensionValuesSelected.forEach(node => {
                this.expandRecursive(node, true);
            });
            this.dimensionValuesSelected = [...this.dimensionValuesSelected];
        }
    }

    expandRangeOne() {
        if (this.dimensionValuesRange1) {
            this.dimensionValuesRange1.forEach(node => {
                this.expandRecursive(node, true);
            });
            this.dimensionValuesRange1 = [...this.dimensionValuesRange1];
        }
    }

    expandRangeTwo() {
        if (this.dimensionValuesRange2) {
            this.dimensionValuesRange2.forEach(node => {
                this.expandRecursive(node, true);
            });
            this.dimensionValuesRange2 = [...this.dimensionValuesRange2];
        }
    }
    leafs: TreeNode[];

    toggleLeavesOnly = false;
    @Input() loadingAccounts = true;

    changeToggleLeavesOnly() {
        if (this.toggleLeavesOnly) {
            this.loadingAccounts = true;
            this.leafs = [];
            this.processLeafs();
            this.accounts = this.leafs;
            this.loadingAccounts = false;
        } else {
            this.refresh();
        }
    }

    leafsRecursive(node: TreeNode) {
        if (node.leaf) {
            node.data.leaf = true;
            this.leafs.push(node);
        }
        if (node.children) {
            node.children.forEach(childNode => {
                this.leafsRecursive(childNode);
            });
        }
        node.children = null;
    }

    processLeafs() {
        this.accounts.forEach(node => {
            this.leafsRecursive(node);
        });
    }
}
